import type { KeyboardEvent, MouseEvent } from 'react';

/**
 * KEEP A PORTAL'S EVENTS INSIDE THE PORTAL (GDN-3380).
 *
 * A portal moves an element in the DOM but not in the React tree, and React
 * replays synthetic events along the COMPONENT hierarchy. So a click on a menu
 * item still bubbles to whatever owns the kebab — and on every queue surface
 * that owner is a table row whose entire area opens the claim (`DataTable`
 * puts `onClick={() => onRowClick?.(row)}` on the row box). The biller presses
 * Archive and the claim opens underneath the dialog.
 *
 * Spread onto the ROOT of each overlay rather than onto every item: there are
 * a dozen clickable things across the menu, the submenu and the dialog, and a
 * per-item guard is a list someone will add the thirteenth item to. Mousedown
 * and keydown go with click because a row is free to listen for those too, and
 * a guard that covered only one of the three would be a guard nobody could
 * reason about.
 */
export const stopPortalEvents = {
  onClick: (event: MouseEvent) => event.stopPropagation(),
  onMouseDown: (event: MouseEvent) => event.stopPropagation(),
  onKeyDown: (event: KeyboardEvent) => event.stopPropagation(),
} as const;
